import { getDisplayLanguageCodes } from "@/lib/constants/languages";

/**
 * Gets the browser's preferred language that matches our supported languages
 * Falls back to 'en' if no match is found
 */
export function getBrowserPreferredLanguage(): string {
  const supportedLanguages = getDisplayLanguageCodes();

  const browserLanguages = navigator.languages || [navigator.language || 'en'];

  for (const browserLang of browserLanguages) {
    if (supportedLanguages.includes(browserLang as any)) {
      return browserLang;
    }

    // Check language code without region (e.g., 'en-US' matches 'en')
    const languageCode = browserLang.split('-')[0];
    if (supportedLanguages.includes(languageCode as any)) {
      return languageCode;
    }

    const matchingLanguage = supportedLanguages.find(lang =>
      lang.startsWith(languageCode + '-')
    );
    if (matchingLanguage) {
      return matchingLanguage;
    }
  }

  return 'en';
}